export default __webpack_public_path__ + "static/media/icon-aide.81d02223.svg";